<template>
    <div class="callout callout-info">
        <label><span class="text-danger">*</span> {{$t('label.is_required')}}</label>
    </div>
</template>

<script>
export default {
    
}
</script>
